import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import FocusDragArea from '../../common/components/FocusDragArea';
import { mediaPickerAvailable, openMediaPicker } from '../mediaPicker';
import { clampZoom } from '../../common/util';
/**
 * Avatar focal-point editor. Shows the stored ORIGINAL (uncropped) avatar
 * image behind a circular mask; dragging/zooming picks which region the
 * server re-crops the real avatar files from. A new source image can be
 * uploaded here or picked from the media manager — repositioning itself
 * never requires a re-upload.
 */
export default class AvatarFocusModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", false);
    _defineProperty(this, "focusX", 50);
    _defineProperty(this, "focusY", 50);
    _defineProperty(this, "zoom", 1);
    _defineProperty(this, "dirty", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.syncFromUser();
  }
  className() {
    return 'CoverStudio-Modal CoverStudio-AvatarModal Modal--small';
  }
  title() {
    return app.translator.trans('tryhackx-cover-studio.forum.avatar.title');
  }
  get user() {
    return this.attrs.user;
  }
  syncFromUser() {
    var _this$user$avatarFocu, _this$user$avatarFocu2, _this$user$avatarZoom;
    this.focusX = Number((_this$user$avatarFocu = this.user.avatarFocusX()) != null ? _this$user$avatarFocu : 50);
    this.focusY = Number((_this$user$avatarFocu2 = this.user.avatarFocusY()) != null ? _this$user$avatarFocu2 : 50);
    this.zoom = clampZoom(Number((_this$user$avatarZoom = this.user.avatarZoom()) != null ? _this$user$avatarZoom : 1));
    this.dirty = false;
  }
  content() {
    const originalUrl = this.user.avatarOriginalUrl();
    return m("div", {
      className: "Modal-body CoverStudio-Editor"
    }, originalUrl ? [m(FocusDragArea, {
      url: originalUrl,
      focusX: this.focusX,
      focusY: this.focusY,
      zoom: this.zoom,
      circle: true,
      onchange: (x, y) => {
        this.focusX = x;
        this.focusY = y;
        this.dirty = true;
      },
      onzoom: this.setZoom.bind(this)
    }), this.zoomControl(), m("p", {
      className: "helpText CoverStudio-Editor-sizeHint"
    }, app.translator.trans('tryhackx-cover-studio.forum.avatar.hint'))] : m("div", {
      className: "CoverStudio-Editor-empty CoverStudio-Editor-empty--avatar"
    }, this.loading ? m(LoadingIndicator, null) : m("p", null, app.translator.trans('tryhackx-cover-studio.forum.avatar.no_original'))), m("div", {
      className: "CoverStudio-Editor-actions"
    }, m(Button, {
      className: "Button",
      icon: "fas fa-upload",
      loading: this.loading,
      onclick: this.openFilePicker.bind(this)
    }, app.translator.trans('tryhackx-cover-studio.forum.editor.upload_button')), mediaPickerAvailable(this.user) && m(Button, {
      className: "Button",
      icon: "fas fa-photo-video",
      disabled: this.loading,
      onclick: this.openMediaManager.bind(this)
    }, app.translator.trans('tryhackx-cover-studio.forum.editor.media_button'))), !!originalUrl && m("div", {
      className: "CoverStudio-Editor-save"
    }, m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-check",
      loading: this.loading,
      disabled: !this.dirty,
      onclick: this.saveFocus.bind(this)
    }, app.translator.trans('tryhackx-cover-studio.forum.editor.save_position_button'))));
  }
  setZoom(zoom) {
    this.zoom = clampZoom(zoom);
    this.dirty = true;
  }
  zoomControl() {
    return m("div", {
      className: "CoverStudio-Editor-zoom"
    }, m("label", {
      htmlFor: "CoverStudio-avatar-zoom"
    }, app.translator.trans('tryhackx-cover-studio.forum.editor.zoom_label')), m("input", {
      id: "CoverStudio-avatar-zoom",
      type: "range",
      min: "0.5",
      max: "3",
      step: "0.05",
      list: "CoverStudio-zoom-ticks-avatar",
      value: this.zoom,
      disabled: this.loading,
      oninput: e => this.setZoom(parseFloat(e.target.value))
    }), m("datalist", {
      id: "CoverStudio-zoom-ticks-avatar"
    }, m("option", {
      value: "1"
    })), m("button", {
      type: "button",
      className: "Button Button--link CoverStudio-Editor-zoomValue",
      title: app.translator.trans('tryhackx-cover-studio.forum.editor.zoom_reset'),
      disabled: this.loading,
      onclick: () => this.setZoom(1)
    }, this.zoom.toFixed(2), "\xD7"));
  }
  openFilePicker() {
    if (this.loading) return;
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/jpeg,image/png,image/webp,image/gif';
    input.addEventListener('change', () => {
      var _input$files;
      const file = (_input$files = input.files) == null ? void 0 : _input$files[0];
      if (file) this.upload(file);
    });
    input.click();
  }
  upload(file) {
    const body = new FormData();
    body.append('avatar', file);
    // A fresh image starts centered, without zoom.
    body.append('focusX', '50');
    body.append('focusY', '50');
    body.append('zoom', '1');
    this.request({
      method: 'POST',
      body,
      serialize: raw => raw
    });
  }
  openMediaManager() {
    openMediaPicker(this.user, fileId => {
      this.request({
        method: 'POST',
        body: {
          fileId,
          focusX: 50,
          focusY: 50,
          zoom: 1
        }
      });
    });
  }
  saveFocus() {
    if (this.loading || !this.dirty) return;
    this.request({
      method: 'PATCH',
      body: {
        focusX: this.focusX,
        focusY: this.focusY,
        zoom: this.zoom
      }
    });
  }
  request(options) {
    this.loading = true;
    this.alertAttrs = null;
    m.redraw();
    app.request(_objectSpread({
      url: "".concat(app.forum.attribute('apiUrl'), "/users/").concat(this.user.id(), "/cover-studio/avatar"),
      method: options.method,
      body: options.body
    }, options.serialize ? {
      serialize: options.serialize
    } : {})).then(response => {
      if (response) app.store.pushPayload(response);

      // Force avatar color recomputation, same as core's AvatarEditor.
      delete this.user.avatarColor;
      this.loading = false;
      this.syncFromUser();
      this.alertAttrs = {
        type: 'success',
        content: app.translator.trans('tryhackx-cover-studio.forum.editor.saved')
      };
      m.redraw();
    }).catch(error => {
      var _error$response;
      this.loading = false;
      this.alertAttrs = {
        type: 'error',
        content: (error == null || (_error$response = error.response) == null || (_error$response = _error$response.errors) == null || (_error$response = _error$response[0]) == null ? void 0 : _error$response.detail) || app.translator.trans('tryhackx-cover-studio.forum.editor.generic_error')
      };
      m.redraw();
    });
  }
}
flarum.reg.add('tryhackx-cover-studio', 'forum/components/AvatarFocusModal', AvatarFocusModal);